import type { ElementType, HTMLAttributes } from 'react'
import type { SpacingToken } from '../../styles/tokens'
import { cx } from '../cx'
import styles from './Grid.module.css'

type SpaceStep = Extract<SpacingToken, `space-${string}`>

type GridProps = Omit<HTMLAttributes<HTMLElement>, 'style' | 'className'> & {
  as?:
    | 'div'
    | 'section'
    | 'ul'
    | 'ol'
    | 'li'
    | 'nav'
    | 'header'
    | 'footer'
    | 'main'
    | 'aside'
    | 'article'
    | 'form'
    | 'fieldset'
  columns: 1 | 2 | 3 | 4
  mdColumns?: 1 | 2 | 3 | 4
  gap: SpaceStep | 'grid-gutter'
  className?: string
}

export function Grid({
  as = 'div',
  columns,
  mdColumns,
  gap,
  className,
  children,
  ...rest
}: GridProps) {
  const Tag: ElementType = as
  return (
    <Tag
      {...rest}
      className={cx(styles.grid, className)}
      data-columns={columns}
      data-md-columns={mdColumns}
      data-gap={gap}
    >
      {children}
    </Tag>
  )
}
